module.exports = __webpack_public_path__ + "static/media/object.cf6c039c.svg";